var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreadcrumbsChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_292_9216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.942414 0.527436C0.532363 0.117385 0.532363 -0.547439 0.942413 -0.957489C1.35246 -1.36754 2.01729 -1.36754 2.42734 -0.957489L8.26097 4.87614C8.7296 5.34477 8.7296 6.10457 8.26097 6.5732L2.42734 12.4068C2.01729 12.8169 1.35246 12.8169 0.942413 12.4068C0.532362 11.9968 0.532363 11.332 0.942413 10.9219L5.29112 6.5732C5.75975 6.10457 5.75975 5.34477 5.29112 4.87614L0.942414 0.527436Z",
    fill: "#A1AEBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_292_9216"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 10,
    height: 10,
    rx: 0.24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbsChevron);
export default __webpack_public_path__ + "static/media/BreadcrumbsChevron.217c3055cca7d41fc6eb9c6b9beb3e4d.svg";
export { ForwardRef as ReactComponent };